module.exports = __webpack_public_path__ + "img/FR10057.d05e5182.png";